import React, { FC, useMemo } from 'react';
import CardList from '../CardList';
import {
  CommonAttributesProps,
  ExtraAttributesSimType,
} from 'screens/AccessExpressV3/accessExpress.types';

interface SimTypeProps extends CommonAttributesProps {
  options: ExtraAttributesSimType[];
  selected: ExtraAttributesSimType | null;
  setSelected: (v: ExtraAttributesSimType) => void;
}

const SimType: FC<SimTypeProps> = ({
  handleStep,
  step,
  options,
  selected,
  setSelected,
}) => {
  const onSelect = (sim: ExtraAttributesSimType) => {
    handleStep && handleStep(step ?? 1);
    setSelected(sim);
  };

  const _options = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        id: option.sim_type,
        title: option.sim_type,
        item: option,
      })),
    [options],
  );

  return (
    <>
      <CardList
        title="SIM type"
        selected={selected?.sim_type ?? null}
        onClick={(sim) => onSelect(sim as ExtraAttributesSimType)}
        options={_options}
      />
    </>
  );
};

export default SimType;
